import type { SubscriptionKeyType } from '@wegic/price-ui';

/**
 * 套餐基础信息
 */
export interface SubscriptionPlanInfo {
  value: number;
  name: string;
}

// Basic Plan
const BASIC_PLAN = {
  m: { value: 39.9, name: 'Basic_Mo' },
  y: { value: 286.8, name: 'Basic_1Yr' },
  y2: { value: 525.6, name: 'Basic_2Yr' },
  y3: { value: 680.4, name: 'Basic_3Yr' },
} as const;

// Pro Plan
const PRO_PLAN = {
  m: { value: 69.9, name: 'Pro_Mo' },
  y: { value: 502.8, name: 'Pro_1Yr' },
  y2: { value: 885.6, name: 'Pro_2Yr' },
  y3: { value: 1220.4, name: 'Pro_3Yr' },
} as const;

// Prepay Plan
const PREPAY_PLAN = {
  prepay: { value: 2.99, name: 'Prepay' },
} as const;

/**
 * 套餐价格映射表
 */
export const SUBSCRIPTION_MAP: Record<SubscriptionKeyType, SubscriptionPlanInfo> = {
  // Lite
  lm: BASIC_PLAN.m,
  ly: BASIC_PLAN.y,
  ly2: BASIC_PLAN.y2,
  ly3: BASIC_PLAN.y3,

  // Basic & Starter
  bm: BASIC_PLAN.m,
  by: BASIC_PLAN.y,
  by2: BASIC_PLAN.y2,
  by3: BASIC_PLAN.y3,

  // Pro & Premium
  pm: PRO_PLAN.m,
  py: PRO_PLAN.y,
  py2: PRO_PLAN.y2,
  py3: PRO_PLAN.y3,

  prepay: PREPAY_PLAN.prepay,
};

/**
 * 获取套餐信息
 */
export function getSubscriptionInfo(key: SubscriptionKeyType): SubscriptionPlanInfo | undefined {
  return SUBSCRIPTION_MAP[key];
}

/**
 * 创建套餐映射表
 * @param transform 转换函数，将 SubscriptionPlanInfo 转换为目标格式
 */
export function createSubscriptionMap<T>(
  transform: (info: SubscriptionPlanInfo) => T,
): Record<SubscriptionKeyType, T> {
  return Object.fromEntries(
    Object.entries(SUBSCRIPTION_MAP).map(([key, info]) => [key, transform(info)]),
  ) as Record<SubscriptionKeyType, T>;
}
